let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8WoNm")).then(() => parcelRequire('kyCKS'));